const normalizeIban = (value: string): string =>
	value.replace(/\s/g, "").toUpperCase();

/** Format only: FI followed by 16 digits, without checksum validation. */
export const hasFinnishIbanFormat = (value: string): boolean =>
	/^FI\d{16}$/.test(normalizeIban(value));

/** Whether two IBANs name the same account, ignoring spaces and case. */
export const isSameIban = (a: string, b: string): boolean => {
	const normalized = normalizeIban(a);
	return normalized !== "" && normalized === normalizeIban(b);
};
